// 数据类型
export const dataTypeOptions = [
  'int',
  'float',
  'double',
  'text',
  'date',
  'bool',
  'enum',
  'struct',
  'array'
]

// int、float、double 类型单位
export const unitOptions = [
  {
    name: 'PH值',
    unit: 'pH'
  },
  {
    name: '土壤EC值',
    unit: 'dS/m'
  },
  {
    name: '太阳总辐射',
    unit: 'W/㎡'
  },
  {
    name: '降雨量',
    unit: 'mm/hour'
  },
  {
    name: '乏',
    unit: 'var'
  },
  {
    name: '厘泊',
    unit: 'cP'
  },
  {
    name: '饱和度',
    unit: 'aw'
  },
  {
    name: '个',
    unit: 'pcs'
  },
  {
    name: '厘斯',
    unit: 'cst'
  },
  {
    name: '巴',
    unit: 'bar'
  },
  {
    name: '纳克每升',
    unit: 'ppt'
  },
  {
    name: '微克每升',
    unit: 'ppb'
  },
  {
    name: '微西每厘米',
    unit: 'uS/cm'
  },
  {
    name: '牛顿每库仑',
    unit: 'N/C'
  },
  {
    name: '伏特每米',
    unit: 'V/m'
  },
  {
    name: '滴速',
    unit: 'ml/min'
  },
  {
    name: '血压',
    unit: 'mmHg'
  },
  {
    name: '血糖',
    unit: 'mmol/L'
  },
  {
    name: '毫米每秒',
    unit: 'mm/s'
  },
  {
    name: '转每分钟',
    unit: 'turn/m'
  },
  {
    name: '次',
    unit: 'count'
  },
  {
    name: '档',
    unit: 'gear'
  },
  {
    name: '步',
    unit: 'stepCount'
  },
  {
    name: '标准立方米每小时',
    unit: 'Nm3/h'
  },
  {
    name: '千伏',
    unit: 'kV'
  },
  {
    name: '千伏安',
    unit: 'kVA'
  },
  {
    name: '千乏',
    unit: 'kVar'
  },
  {
    name: '微瓦每平方厘米',
    unit: 'uw/cm2'
  },
  {
    name: '只',
    unit: '只'
  },
  {
    name: '相对湿度',
    unit: '%RH'
  },
  {
    name: '立方米每秒',
    unit: 'm³/s'
  },
  {
    name: '公斤每秒',
    unit: 'kg/s'
  },
  {
    name: '转每分钟',
    unit: 'r/min'
  },
  {
    name: '吨每小时',
    unit: 't/h'
  },
  {
    name: '千卡每小时',
    unit: 'KCL/h'
  },
  {
    name: '升每秒',
    unit: 'L/s'
  },
  {
    name: '兆帕',
    unit: 'Mpa'
  },
  {
    name: '立方米每小时',
    unit: 'm³/h'
  },
  {
    name: '千乏时',
    unit: 'kvarh'
  },
  {
    name: '微克每升',
    unit: 'μg/L'
  },
  {
    name: '千卡路里',
    unit: 'kcal'
  },
  {
    name: '吉字节',
    unit: 'GB'
  },
  {
    name: '兆字节',
    unit: 'MB'
  },
  {
    name: '千字节',
    unit: 'KB'
  },
  {
    name: '字节',
    unit: 'B'
  },
  {
    name: '微克每平方分米每天',
    unit: 'μg/(d㎡·d)'
  },
  {
    name: '百万分率',
    unit: 'ppm'
  },
  {
    name: '像素',
    unit: 'pixel'
  },
  {
    name: '照度',
    unit: 'Lux'
  },
  {
    name: '重力加速度',
    unit: 'grav'
  },
  {
    name: '分贝',
    unit: 'dB'
  },
  {
    name: '百分比',
    unit: '%'
  },
  {
    name: '流明',
    unit: 'lm'
  },
  {
    name: '比特',
    unit: 'bit'
  },
  {
    name: '克每毫升',
    unit: 'g/mL'
  },
  {
    name: '克每升',
    unit: 'g/L'
  },
  {
    name: '毫克每升',
    unit: 'mg/L'
  },
  {
    name: '微克每立方米',
    unit: 'μg/m³'
  },
  {
    name: '毫克每立方米',
    unit: 'mg/m³'
  },
  {
    name: '千克每立方米',
    unit: 'kg/m³'
  },
  {
    name: '纳法',
    unit: 'nF'
  },
  {
    name: '皮法',
    unit: 'pF'
  },
  {
    name: '微法',
    unit: 'μF'
  },
  {
    name: '法拉',
    unit: 'F'
  },
  {
    name: '欧姆',
    unit: 'Ω'
  },
  {
    name: '微安',
    unit: 'μA'
  },
  {
    name: '毫安',
    unit: 'mA'
  },
  {
    name: '千安',
    unit: 'kA'
  },
  {
    name: '安培',
    unit: 'A'
  },
  {
    name: '毫伏',
    unit: 'mV'
  },
  {
    name: '伏特',
    unit: 'V'
  },
  {
    name: '毫秒',
    unit: 'ms'
  },
  {
    name: '秒',
    unit: 's'
  },
  {
    name: '分钟',
    unit: 'min'
  },
  {
    name: '小时',
    unit: 'h'
  },
  {
    name: '日',
    unit: 'day'
  },
  {
    name: '周',
    unit: 'week'
  },
  {
    name: '月',
    unit: 'month'
  },
  {
    name: '年',
    unit: 'year'
  },
  {
    name: '节',
    unit: 'kn'
  },
  {
    name: '千米每小时',
    unit: 'km/h'
  },
  {
    name: '米每秒',
    unit: 'm/s'
  },
  {
    name: '秒',
    unit: '″'
  },
  {
    name: '分',
    unit: '′'
  },
  {
    name: '度',
    unit: '°'
  },
  {
    name: '弧度',
    unit: 'rad'
  },
  {
    name: '赫兹',
    unit: 'Hz'
  },
  {
    name: '微瓦',
    unit: 'μW'
  },
  {
    name: '毫瓦',
    unit: 'mW'
  },
  {
    name: '千瓦特',
    unit: 'kW'
  },
  {
    name: '瓦特',
    unit: 'W'
  },
  {
    name: '卡路里',
    unit: 'cal'
  },
  {
    name: '千瓦时',
    unit: 'kW·h'
  },
  {
    name: '瓦时',
    unit: 'Wh'
  },
  {
    name: '电子伏',
    unit: 'eV'
  },
  {
    name: '千焦',
    unit: 'kJ'
  },
  {
    name: '焦耳',
    unit: 'J'
  },
  {
    name: '华氏度',
    unit: '℉'
  },
  {
    name: '开尔文',
    unit: 'K'
  },
  {
    name: '吨',
    unit: 't'
  },
  {
    name: '摄氏度',
    unit: '°C'
  },
  {
    name: '毫帕',
    unit: 'mPa'
  },
  {
    name: '百帕',
    unit: 'hPa'
  },
  {
    name: '千帕',
    unit: 'kPa'
  },
  {
    name: '帕斯卡',
    unit: 'Pa'
  },
  {
    name: '毫克',
    unit: 'mg'
  },
  {
    name: '克',
    unit: 'g'
  },
  {
    name: '千克',
    unit: 'kg'
  },
  {
    name: '牛',
    unit: 'N'
  },
  {
    name: '毫升',
    unit: 'mL'
  },
  {
    name: '升',
    unit: 'L'
  },
  {
    name: '立方毫米',
    unit: 'mm³'
  },
  {
    name: '立方厘米',
    unit: 'cm³'
  },
  {
    name: '立方千米',
    unit: 'km³'
  },
  {
    name: '立方米',
    unit: 'm³'
  },
  {
    name: '公顷',
    unit: 'h㎡'
  },
  {
    name: '平方厘米',
    unit: 'c㎡'
  },
  {
    name: '平方毫米',
    unit: 'm㎡'
  },
  {
    name: '平方千米',
    unit: 'k㎡'
  },
  {
    name: '平方米',
    unit: '㎡'
  },
  {
    name: '纳米',
    unit: 'nm'
  },
  {
    name: '微米',
    unit: 'μm'
  },
  {
    name: '毫米',
    unit: 'mm'
  },
  {
    name: '厘米',
    unit: 'cm'
  },
  {
    name: '分米',
    unit: 'dm'
  },
  {
    name: '千米',
    unit: 'km'
  },
  {
    name: '米',
    unit: 'm'
  }
]

// array 元素类型
export const arrayDatatypeOptions = ['int', 'float', 'double', 'text', 'struct']
// 长度类型
export const lengthTypeOptions = ['byte', 'bit']
